<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">
        Đăng ký yêu cầu đặt vé máy bay
      </h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="150px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Tên yêu cầu" prop="requestName">
              <el-input
                v-model="form.requestName"
                placeholder="Tên yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="100"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Nội dung yêu cầu" prop="requestContent">
              <el-input
                type="textarea"
                v-model="form.requestContent"
                placeholder="Nội dung yêu cầu"
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                size="medium"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 2, maxRows: 5 }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-maybay-upload
              ref="hcMaybayUpload"
              :hcCaseFlightFileType="HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH"
              :validateUploadFileOptions="toTrinhValidateFileOptions"
            ></hc-maybay-upload>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-maybay-users ref="hcMaybayUsers"></hc-maybay-users>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="24">
            <hc-maybay-routes ref="hcMaybayRoutes"></hc-maybay-routes>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="submit"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Gửi yêu cầu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>
<script>
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import HcMaybayUsers from "./hc-maybay-users";
import HcMaybayRoutes from "./hc-maybay-routes";
import CustomDialog from "../../common/custom-dialog";
import HcMaybayUpload from "./hc-maybay-upload";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import hcFlowService from "../../../services/hcFlowService";
import hcCaseFlightService from "../../../services/maybay/hcCaseFlightService";
import constants from "../../../constants";
import hanhChinhUtils from "../../../services/hanhChinhUtils";

export default {
  name: "hc-maybay-create-dialog",
  mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
  props: ["isOpen", "id", "flowId"],
  components: {
    HcMaybayRoutes,
    HcMaybayUpload,
    CustomDialog,
    HcMaybayUsers
  },

  data() {
    return {
      rules: {
        requestName: null,
        requestContent: null,
        flightFileList: null,
        flightUserList: null,
        flightRouteList: null
      },
      form: {
        requestName: null,
        requestContent: null,
        flightFileList: [],
        flightUserList: [],
        flightRouteList: []
      },
      hcFlow: null,
      HC_CASE_FLIGHT_FILE: constants.HC_CASE_FLIGHT_FILE,
      toTrinhValidateFileOptions: null
    };
  },

  computed: {},

  watch: {},

  created() {
    this.initValidationRules();
    this.initMayBayFileValidateFileOptions();
    this.loadHcFlow();
  },

  methods: {
    initMayBayFileValidateFileOptions() {
      this.toTrinhValidateFileOptions =
        hanhChinhUtils.initMayBayFileValidateFileOptions(constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH);
    },

    loadHcFlow() {
      return hcFlowService.getHcFlowAlternativeForHcFlight().then(response => {
        this.hcFlow = response.data;
        this.flowId = this.hcFlow.id;
      });
    },

    initValidationRules() {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };
      this.rules.requestName = [defaultRequiredConstrains];
      this.rules.requestContent = [defaultRequiredConstrains];
      // this.rules.flightFileList = [defaultRequiredConstrains];
      // this.rules.flightUserList = [defaultRequiredConstrains];
      // this.rules.flightRouteList = [defaultRequiredConstrains];
    },

    validateUploadFiles() {
      return new Promise(resolve => {
        let files = this.$refs.hcMaybayUpload.getData();
        if (!files || !files.length) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcMayBay.files.required" })
          );
        } else {
          resolve();
        }
      });
    },

    validateUsers() {
      return new Promise(resolve => {
        let files = this.$refs.hcMaybayUsers.getData();
        if (!files || !files.length) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcMayBay.users.required" })
          );
        } else {
          resolve();
        }
      });
    },

    validateRoutes() {
      return new Promise(resolve => {
        let files = this.$refs.hcMaybayRoutes.getData();
        if (!files || !files.length) {
          this.$message.error(
            errorMessageFilter({ errorCode: "hcMayBay.routes.required" })
          );
        } else {
          resolve();
        }
      });
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (!valid) {
            this.$message.error("Có lỗi nhập liệu. Vui lòng kiểm tra lại");
          } else {
            resolve();
          }
        });
      });
    },

    convertToSubmitForm() {
      return {
        flowId: this.hcFlow ? this.hcFlow.id : null,
        requestName: this.form.requestName,
        requestContent: this.form.requestContent,
        flightFileList: this.$refs.hcMaybayUpload.getData(),
        flightUserList: this.$refs.hcMaybayUsers.getData(),
        flightRouteList: this.$refs.hcMaybayRoutes.getData()
      };
    },

    submit() {
      this.validateForm()
        .then(() => this.validateUploadFiles())
        .then(() => this.validateUsers())
        .then(() => this.validateRoutes())
        .then(() => {
          let submitForm = this.convertToSubmitForm();
          return hcCaseFlightService
            .create(submitForm)
            .then(response => response.data);
        })
        .then(hcCaseFlight => {
          this.$message.success(
            errorMessageFilter({
              errorCode: "hcFlight.insertSuccess"
            })
          );
          this.$emit("insertSuccess", { result: hcCaseFlight });
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    }
  }
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-create-dialog.vue